import {Button} from 'react-bootstrap';
import createReactClass from 'create-react-class';

import CONFIG from '../global/libs/CONFIG.js';
import PropTypes from 'prop-types';

let QACandidatePanelBottomMailModal = createReactClass({
  // ARGS: question

  propTypes: {
    question: PropTypes.string.isRequired,
    result: PropTypes.object,
    logId: PropTypes.number,
    cgId: PropTypes.string
  },

  getInitialState() {
    return {
      mailModal: false,
      question: this.props.question,
      questionExplain: '',
      name: '',
      affiliation: '',
      mailAddr: ''
    };
  },

  openInquiryCreate() {
    const MAX_LENGTH = 1000;
    let question = this.props.question;
    let qa_id = this.props.result ? this.props.result.id : undefined;
    let user_q_id = this.props.logId;
    let qa_query = '';
    let cg_id = this.props.cgId;

    if (question.length > MAX_LENGTH) {
      question = question.substring(0, MAX_LENGTH);
    }
    qa_query = qa_id ? '&qa=' + qa_id : '';
    qa_query += user_q_id ? '&user_q_id=' + user_q_id : '';
    qa_query += cg_id ? '&cg_id=' + encodeURIComponent(cg_id) : '';
    const INQUIRY_CREATE_SITE = CONFIG.INQUIRY_URL + '/?question=' + encodeURIComponent(question) + qa_query;
    window.open(INQUIRY_CREATE_SITE);
  },

  closeMailModal() {
    this.setState({mailModal: false});
  },

  handleQuestionChange(e) {
    this.setState({question: e.target.value});
  },

  handleQuestionExplainChange(e) {
    this.setState({questionExplain: e.target.value});
  },

  handleNameChange(e) {
    this.setState({name: e.target.value});
  },

  handleAffiliationChange(e) {
    this.setState({affiliation: e.target.value});
  },

  handleMailAddrChange(e) {
    this.setState({mailAddr: e.target.value});
  },

  render() {
    return (
      <span>
        <Button variant="primary" onClick={this.openInquiryCreate}>
          お問い合わせ
        </Button>
      </span>
    );
  }
});

export default QACandidatePanelBottomMailModal;
